
import * as React from "react"
import { Wrapper } from "@googlemaps/react-wrapper"
import SpinerOverlay from "@vfgroup-oneplatform/foundation/Components/SpinnerOverlay/SpinnerOverlay"

import useDeepCompareEffectForMaps from './useDeepCompareEffectForMaps'
import { View } from "native-base";
import { Icon, VFButton, VFInput } from "@vfgroup-oneplatform/foundation/Components";
import { isFunction } from "lodash";
import { Images } from "@vfgroup-oneplatform/foundation/Components/Themes";

import Renewalsimages from '@vfal-lab/rn-vfg-renewals-fix/Themes/Images'


const Marker = (options) => {
    const [marker, setMarker] = React.useState();

    React.useEffect(() => {
        if (!marker) {
            if (options.isUserLocation) {
                setMarker(new google.maps.Marker({
                    icon: 'https://www.robotwoods.com/dev/misc/bluecircle.png'
                }))
            } else {
                setMarker(new google.maps.Marker())
            }
        }
        return () => {
            if (marker) {
                marker.setMap(null)
            }
        };
    }, [marker]);
    React.useEffect(() => {
        if (marker) {
            marker.setOptions(options);
        }
    }, [marker, options]);

    return null;
};

const Map = ({
    onClick,
    onIdle,
    children,
    style,
    serviceAreas,
    setSuccessSearch,
    UnlimitedHome,
    validateLocation,
    setClicks,
    autocompleteRef,
    setCenter,
    setZoom,
    getRoadName,
    setServiceAreas,
    ...options }) => {

    const ref = React.useRef(null);
    const [map, setMap] = React.useState(null);
    const polygonRef = React.useRef([])
    const inputRef = React.useRef()
    // const autocompleteRef = React.useRef()

    React.useEffect(() => {
        if (!inputRef.current) {
            inputRef.current = document.getElementById('InputAutocomplete')
            const Autocomplete = new google.maps.places.Autocomplete(inputRef.current, {
                componentRestrictions: {
                    country: ['AL']
                }
            })
            inputRef.current.placeholder = ' '

            Autocomplete.addListener("place_changed", () => {
                const place = Autocomplete.getPlace();
                autocompleteRef.current.state.text = place.formatted_address
                setZoom(15)
                const latLng = {
                    lat: place.geometry.location.lat,
                    lng: place.geometry.location.lng
                }
                setCenter({
                    lat: latLng.lat(),
                    lng: latLng.lng()
                })
                onClick({
                    latLng: { ...latLng }
                })

                setClicks([new google.maps.LatLng(latLng.lat(), latLng.lng())])
            })

            document.getElementById('InputAutocomplete').onfocus = (e) => {
                const parentElement = document.getElementById('autcompleteWrapper')
                const left = parentElement.getBoundingClientRect().left
                const top = parentElement.getBoundingClientRect().top + parentElement.getBoundingClientRect().height
                const elementWidth = parentElement.clientWidth
                document.getElementsByClassName('pac-container')[0].style.width = '560px !important'
                var styles = `.pac-container{width:${elementWidth}px !important;top:${top}px !important;left:${left}px !important;}`
                var styleSheet = document.createElement("style")
                styleSheet.innerText = styles
                document.head.appendChild(styleSheet)
            }

        }
    }, [])


    React.useEffect(() => {
        if (ref.current && !map) {
            setMap(new window.google.maps.Map(ref.current, {
                disableDefaultUI: true,
            }));
        }
    }, [ref, map]);

    useDeepCompareEffectForMaps(() => {
        if (map) {
            map.setOptions(options);
        }
    }, [map, options]);

    React.useEffect(() => {
        if (map) {
            ["click", "idle"].forEach((eventName) =>
                google.maps.event.clearListeners(map, eventName)
            );
            if (onClick) {
                map.addListener("click", (e) => {
                    setServiceAreas([])
                    onClick(e)
                    getRoadName({ lat: e.latLng.lat(), lng: e.latLng.lng() })
                });
            }

            if (onIdle) {
                map.addListener("idle", () => onIdle(map));
            }
        }
    }, [map, onClick, onIdle]);

    const handlePolygons = (serviceAreas) => {
        if (UnlimitedHome) {
            const Polygons = []
            polygonRef.current.forEach(item => {
                item?.setMap(null)
            })
            polygonRef.current = []
            serviceAreas?.map(item => {
                let items = []
                item?.map((_item) => {
                    items.push({
                        lat: Number(_item?.y?.toPrecision(7)),
                        lng: Number(_item?.x?.toPrecision(7))
                    })
                })
                Polygons.push(new google.maps.Polygon({
                    paths: items,
                    strokeColor: "#117C92",
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: "rgba(17, 125, 146, 0.6)",
                    fillOpacity: 0.35,
                }))
            })
            Polygons?.map(itemPolygon => {
                polygonRef.current = [...polygonRef.current, itemPolygon]
                itemPolygon.setMap(map)
                google.maps.event.addListener(itemPolygon, 'click', function (event) {
                    setClicks([event.latLng])
                    validateLocation(event)
                    getRoadName({ lat: event.latLng.lat(), lng: event.latLng.lng() })
                });
            })

            return;
        }
        let items = []
        serviceAreas.map((item) => {
            items.push({
                lat: Number(item?.y?.toPrecision(7)),
                lng: Number(item?.x?.toPrecision(7))
            })
        })

        const Polygons = new google.maps.Polygon({
            paths: items,
            strokeColor: "#117C92",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "rgba(17, 125, 146, 0.6)",
            fillOpacity: 0.35,
        });
        polygonRef.current = Polygons



        google.maps.event.addListener(Polygons, 'click', function (event) {
            onClick(event)
            getRoadName({ lat: event.latLng.lat(), lng: event.latLng.lng() })
        });
    }

    const removePolygon = () => {
        polygonRef?.current?.setMap(null)
    }

    React.useEffect(() => {
        if (serviceAreas.length > 0) {
            handlePolygons(serviceAreas)
        }
        // if (serviceAreas.length === 0) {
        //     removePolygon()
        // }
    }, [serviceAreas.length])


    return (
        <>
            <div ref={ref} style={style} />
            {React.Children.map(children, (child) => {
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, { map });
                }
            })}
        </>
    );

};


export const MapWrapper = ({
    onSearch,
    serviceAreas,
    setServiceAreas,
    areItemsFetching,
    theme,
    isErrorSearch,
    successSearch,
    goToSteps,
    onCancelNotifyMe,
    toggleModal,
    NoCover,
    setSuccessSearch,
    API_KEY = 'AIzaSyDgZm5OUSqiyK7fEstVVKhQCtQvkEvXjZo',
    UnlimitedHome = false,
    onMapShow,
    validateLocation,
    inputStyle,
    isSearching,
    streetName,
    getRoadName
}) => {
    const [clicks, setClicks] = React.useState([])
    const [zoom, setZoom] = React.useState(15)
    const [center, setCenter] = React.useState({
        lat: 41.32,
        lng: 19.81,
    });
    const autocompleteRef = React.useRef()
    const isLocationAvaivable = React.useRef(false)

    const [userLocation, setUserLocation] = React.useState({
        lat: 0,
        lng: 0
    })

    const onClick = (e) => {
        setServiceAreas([])
        setClicks([e.latLng]);
        onSearch(
            {
                longitude: e.latLng.lng(),
                latitude: e.latLng.lat(),
            }
        )
    };

    const onIdle = (m) => {
        setZoom(m.getZoom());
        setCenter({
            lat: m.center.lat(),
            lng: m.center.lng()
        })
    };

    const validateCurrentGeo = () => {
        navigator.geolocation.getCurrentPosition(({ coords }) => {
            const body = {
                latLng: new google.maps.LatLng(coords.latitude, coords.longitude)
            }
            validateLocation(body)
            getRoadName({ lat: coords.latitude, lng: coords.longitude })
            setCenter({
                lat: coords.latitude,
                lng: coords.longitude
            })
        }
        )
    }


    React.useEffect(() => {
        navigator.geolocation.getCurrentPosition(({ coords }) => {
            setUserLocation({
                lat: coords.latitude,
                lng: coords.longitude
            })
            setCenter({
                lat: coords.latitude,
                lng: coords.longitude
            })
        }, null, { timeout: 10000 })
    }, [])

    React.useEffect(() => {
        navigator.geolocation.getCurrentPosition(() => {
            isLocationAvaivable.current = true
        })
        isFunction(onMapShow) && onMapShow()
    }, [])

    React.useEffect(() => {
        if (streetName && autocompleteRef) {
            autocompleteRef.current.state.text = streetName
            if (!autocompleteRef.current.props.receivedFocus) {
                autocompleteRef.current?.inputRef?.current.setAttribute('inputMode', 'none')
                autocompleteRef.current?.onPress()
                autocompleteRef.current.blur()
                autocompleteRef.current?.inputRef?.current.removeAttribute('inputMode')
            }

        }
    }
        , [streetName])


    return (
        <div style={{ height: "100%", position: 'relative' }} >
            <div
                id='autcompleteWrapper'
                style={{
                    backgroundColor: 'white',
                    position: 'absolute',
                    width: '100%',
                    zIndex: 999,
                    top: -1,
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 6,
                    flex: 1,
                    alignItems: 'center',
                    ...inputStyle
                }}>
                <VFInput
                    label="search_input_label"
                    inputProps={{ nativeID: 'InputAutocomplete' }}
                    ref={autocompleteRef}
                    style={{ flex: 1 }}
                    containerStyle={{ flex: 1 }}
                    inputmode="none"
                />
                <div
                    onClick={validateCurrentGeo}
                    style={{
                        backgroundColor: isLocationAvaivable.current ? 'red' : 'gray',
                        borderRadius: 6,
                        height: 50,
                        width: 50,
                        marginRight: 6,
                        alignSelf: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <img
                        filter={'brightness(0) invert(1)'}
                        width={50}
                        height={50}
                        src={`data:image/png;base64${Renewalsimages.indicator.uri}`}
                    />
                </div>
            </div>
            <Wrapper apiKey={API_KEY} libraries={['places']}>
                <Map
                    center={center}
                    onClick={onClick}
                    onIdle={onIdle}
                    zoom={zoom}
                    style={{ flexGrow: "1", height: "100%" }}
                    serviceAreas={serviceAreas}
                    setSuccessSearch={setSuccessSearch}
                    UnlimitedHome={UnlimitedHome}
                    validateLocation={validateLocation}
                    setClicks={setClicks}
                    autocompleteRef={autocompleteRef}
                    setCenter={setCenter}
                    setZoom={setZoom}
                    getRoadName={getRoadName}
                    setServiceAreas={setServiceAreas}
                >
                    <Marker key={1} position={userLocation} isUserLocation={true} />
                    {clicks.map((latLng, i) => (
                        <Marker key={i} position={latLng} isUserLocation={false} />
                    ))}
                </Map>
                {/* {true && <SpinerOverlay
                    isVisible autoPlay lottieStyle={{
                        width: 200,
                        height: 200,
                    }} />} */}
            </Wrapper>
            {successSearch && <View
                style={{
                    marginTop: '-15%',
                    marginHorizontal: '10%'
                }}
            >
                <VFButton
                    type="primary"
                    title="renewals_view_offer_button"
                    onPress={goToSteps}
                />
            </View>}

            {isErrorSearch && <NoCover onCancelNotifyMe={onCancelNotifyMe} theme={theme} toggleModal={toggleModal} />}

        </div>
    );
};
